import {
  createManager,
  deleteManager,
  getManager,
  searchManagers,
  updateManager,
} from 'shared/api/managers';
import {
  createComplex,
  deleteComplex,
  getComplex,
  searchComplexes,
  updateComplex,
} from 'shared/api/complexes';
import {
  createDirectvPackage,
  deleteDirectvPackage,
  getDirectvPackage,
  searchDirectvPackages,
  updateDirectvPackage,
} from 'shared/api/directv';
import {
  createAccessControl,
  createFire,
  createIntrusion,
  createSurveillance,
  deleteAccessControl,
  deleteFire,
  deleteIntrusion,
  deleteSurveillance,
  getAccessControl,
  getFire,
  getIntrusion,
  getSurveillance,
  searchAccessControl,
  searchFire,
  searchIntrusion,
  searchSurveillance,
  updateAccessControl,
  updateFire,
  updateIntrusion,
  updateSurveillance,
} from 'shared/api/security';
import {
  createAvControl,
  deleteAvControl,
  getAvControl,
  searchAvControl,
  updateAvControl,
} from 'features/building/api/av';
import {
  createRemotePowerManagement,
  deleteRemotePowerManagement,
  getRemotePowerManagement,
  searchRemotePowerManagement,
  updateRemotePowerManagement,
} from 'features/building/api/remote-power-management';
import {
  createSatellitePkg,
  deleteSatellitePkg,
  getSatellitePkg,
  searchSatellitePkgs,
  updateSatellitePkg,
} from 'shared/api/satellite-pkgs';
import withResourceManager from './withResourceManager';

export const PropertyManagerResource = withResourceManager(
  {
    title: 'Property Managers',
    resourceType: 'property manager',
    filterKey: 'manager_id',
    withNotes: true,
  },
  {
    getResource: getManager,
    searchResources: searchManagers,
    createResource: createManager,
    deleteResource: deleteManager,
    updateResource: updateManager,
  },
);

export const PropertyComplexResource = withResourceManager(
  {
    title: 'Property Complexes',
    resourceType: 'property complex',
    filterKey: 'complex_id',
    withNotes: true,
  },
  {
    getResource: getComplex,
    searchResources: searchComplexes,
    createResource: createComplex,
    deleteResource: deleteComplex,
    updateResource: updateComplex,
  },
  true,
);

export const DirectvPackageResource = withResourceManager(
  {
    title: 'DirecTV Packages',
    resourceType: 'DirecTV package',
    filterKey: 'dtv_p_id',
  },
  {
    getResource: getDirectvPackage,
    searchResources: searchDirectvPackages,
    createResource: createDirectvPackage,
    deleteResource: deleteDirectvPackage,
    updateResource: updateDirectvPackage,
  },
  true,
);

export const SatellitePkgResource = withResourceManager(
  {
    title: 'Satellite Packages',
    resourceType: 'Package',
    filterKey: 'satellite_package_id',
  },
  {
    getResource: getSatellitePkg,
    searchResources: searchSatellitePkgs,
    createResource: createSatellitePkg,
    deleteResource: deleteSatellitePkg,
    updateResource: updateSatellitePkg,
  },
  true,
);

export const AccessControlResource = withResourceManager(
  {
    title: 'Access Control Vendors',
    resourceType: 'Vendor',
    filterKey: 'access_control_id',
  },
  {
    getResource: getAccessControl,
    searchResources: searchAccessControl,
    createResource: createAccessControl,
    deleteResource: deleteAccessControl,
    updateResource: updateAccessControl,
  },
  true,
);

export const AvControlResource = withResourceManager(
  {
    title: 'Av Control Systems',
    resourceType: 'System',
    filterKey: 'control_system_id',
  },
  {
    getResource: getAvControl,
    searchResources: searchAvControl,
    createResource: createAvControl,
    deleteResource: deleteAvControl,
    updateResource: updateAvControl,
  },
  true,
);

export const FireResource = withResourceManager(
  {
    title: 'Fire Monitors',
    resourceType: 'Fire Monitor',
    filterKey: 'fire_monitor_id',
  },
  {
    getResource: getFire,
    searchResources: searchFire,
    createResource: createFire,
    deleteResource: deleteFire,
    updateResource: updateFire,
  },
  true,
);

export const RemotePowerManagementResource = withResourceManager(
  {
    title: 'Remote Power Management Systems',
    resourceType: 'System',
    filterKey: 'remote_power_management_id',
  },
  {
    getResource: getRemotePowerManagement,
    searchResources: searchRemotePowerManagement,
    createResource: createRemotePowerManagement,
    deleteResource: deleteRemotePowerManagement,
    updateResource: updateRemotePowerManagement,
  },
  true,
);

export const SurveillanceResource = withResourceManager(
  {
    title: 'Surveillance Vendors',
    resourceType: 'Surveillance Vendor',
    filterKey: 'surveillance_id',
  },
  {
    getResource: getSurveillance,
    searchResources: searchSurveillance,
    createResource: createSurveillance,
    deleteResource: deleteSurveillance,
    updateResource: updateSurveillance,
  },
  true,
);

export const IntrusionResource = withResourceManager(
  {
    title: 'Intrusion Monitors',
    resourceType: 'Intrusion Monitor',
    filterKey: 'intrusion_monitor_id',
  },
  {
    getResource: getIntrusion,
    searchResources: searchIntrusion,
    createResource: createIntrusion,
    deleteResource: deleteIntrusion,
    updateResource: updateIntrusion,
  },
  true,
);
